import React from 'react';
import { useParams } from 'react-router-dom';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import { EmailField, PhoneField, TextField } from 'framework/ui/field';
import EditContactButton from 'domain/sales/contact/shared/button/EditContactButton';
import ContactLinkField from 'domain/sales/contact/shared/field/ContactLinkField';
import useContactService, { CREATE_CONTACT } from '../shared/contactService';
import { CreateButton } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const RelatedContactsList = () => {
  const { data: accountData } = useShowContext();
  const accountName = accountData.getValueBySource('accountName');
  const { id = '' } = useParams<Dictionary<string>>();
  const { search } = useContactService();
  const { getCreateUrl } = useContactUrl();

  const getDataMethod = async (params: any) => {
    return search({
      filter: {
        'account.alias': { eq: id },
      },
      ...params,
    });
  };

  return (
    <RelatedList getDataMethod={getDataMethod}>
      <RelationListLayout
        header="Contacts"
        headerVariant="h4"
        actions={[
          <CreateButton
            url={`${getCreateUrl({
              accountId: id,
              accountName,
            })}`}
            variant="contained"
            label="Create contact"
            size="small"
            key="create-opportunity"
            permissionToCheck={CREATE_CONTACT}
          />,
        ]}
      >
        <DataGridLayout buttons={[<EditContactButton outline source="id" />]} isSmallTable showTotal={false}>
          <ContactLinkField
            linkText={(data: any) => `${data.getValueBySource('firstName')} ${data.getValueBySource('lastName')}`}
            idSource="id"
            label="Contact name"
          />
          <TextField source="title" label="Title" width={400} />
          <EmailField source="emails[0]" label="Email" />
          <PhoneField source="phoneNumber" label="Phone" />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedList>
  );
};

export default RelatedContactsList;
